import React, { useEffect, useRef } from "react";
import { SendBox, SendBoxProps, usePropsFor } from "@azure/communication-react";
import { sendBoxStyles, usePcpInputStyles } from "../BaseComponents";
import { mergeStyles } from "@fluentui/react";
import { ArrowRightFilled } from "@fluentui/react-icons";


// NOTE: The SendBox is wrapped in a Stack which has a border.
//             It's not possible to style this stack/border using styles input,
//             only via theming.
//             Theme is not suited as a global borderRadius of 25px would break the design.
const removeStackBorder = {
    '> .ms-Stack > .ms-Stack': {
        border: '0 !important',
        margin: '0',
    },
};

interface PcpSendBoxProps extends SendBoxProps {
    isShown: boolean;
}

export const PcpSendBox = (props: PcpSendBoxProps): JSX.Element => {
    const { autoFocus, isShown } = props;
    const textFieldContainerRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (autoFocus === "sendBoxTextField") {
            if (isShown && textFieldContainerRef.current) {
                //searching for "sendTextFieldRef.current" inside <SendBox> component:
                const textAreaElement = textFieldContainerRef.current.querySelector<HTMLInputElement | HTMLTextAreaElement>("#sendbox");
                setTimeout(() => textAreaElement?.focus(), 200);    //a timeout might be necessary due to how React handles rendering and the timing of DOM updates
            }
        }
    }, [autoFocus, isShown]);

    return (
        <div
            className={mergeStyles(removeStackBorder)}
            ref={textFieldContainerRef as React.RefObject<HTMLDivElement>}
        >
            <SendBox
                {...props}
                styles={sendBoxStyles}
                onRenderIcon={() => <ArrowRightFilled  />}
                supportNewline={true}
            />
        </div>
    );
};
